export const CHARTS_DATA_PERIOD = 28; // days
export const CHARTS_NUMBER_OF_PERIODS = 2;
// We want last 8 weeks shown on the charts, but last 60 days in the CSVs
export const CSV_DATA_PERIOD = 60; // days
export const TABLE_DATA_PERIOD = 30; // days

export const CHARTS_PEAK_ACTIVE_COLOR = 'green';
export const CHARTS_PEAK_PAST_COLOR = 'greenGray';
export const CHARTS_TESTS_ACTIVE_COLOR = 'darkBlue';
export const CHARTS_TESTS_PAST_COLOR = 'darkBlueGray';

export const CSV = 'csv';
